import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'umbrella-closed', 'UmbrellaClosed', [["path",{"d":"M9 16l3 -13l3 13l-6 0"}],["path",{"d":"M12 16v3c0 2.667 4 2.667 4 0"}]]);